import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PropertyVisit_Create, PropertyVisit_Delete, PropertyVisit_ReadByBusinessId, PropertyVisit_ReadById, PropertyVisit_ReadByMasterId, PropertyVisit_ReadByVisitorUserId, PropertyVisit_Update } from "src/app/GlobalVariable";
import { PropertyVisitCreateRequestDTO, PropertyVisitDeleteRequestDTO, PropertyVisitDTO, PropertyVisitList, PropertyVisitReadByBusinessIdRequestDTO, PropertyVisitReadByIdRequestDTO, PropertyVisitReadByMasterIdRequestDTO, PropertyVisitReadByVisitorUserIdRequestDTO, PropertyVisitUpdateRequestDTO } from "./propertyVisit.interface";

@Injectable({
    providedIn: 'root'
})

export class PropertyVisitService {
    private http = inject(HttpClient);

    PropertyVist_Create(data: PropertyVisitCreateRequestDTO): Observable<PropertyVisitDTO> {
        return this.http.post<PropertyVisitDTO>(PropertyVisit_Create, data);
    }

    PropertyVist_Update(data: PropertyVisitUpdateRequestDTO): Observable<PropertyVisitDTO> {
        return this.http.post<PropertyVisitDTO>(PropertyVisit_Update, data);
    }

    PropertyVist_Delete(data: PropertyVisitDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(PropertyVisit_Delete, data);
    }

    PropertyVist_ReadAll(): Observable<PropertyVisitList> {
        return this.http.get<PropertyVisitList>(PropertyVisit_Create);
    }

    PropertyVist_ReadById(data: PropertyVisitReadByIdRequestDTO): Observable<PropertyVisitDTO> {
        return this.http.post<PropertyVisitDTO>(PropertyVisit_ReadById, data);
    }

    PropertyVist_ReadByMasterId(data: PropertyVisitReadByMasterIdRequestDTO): Observable<PropertyVisitList> {
        return this.http.post<PropertyVisitList>(PropertyVisit_ReadByMasterId, data);
    }

    PropertyVist_ReadByVisitorUserId(data: PropertyVisitReadByVisitorUserIdRequestDTO): Observable<PropertyVisitDTO> {
        return this.http.post<PropertyVisitDTO>(PropertyVisit_ReadByVisitorUserId, data);
    }

    PropertyVist_ReadByBusinessId(data: PropertyVisitReadByBusinessIdRequestDTO): Observable<PropertyVisitList> {
        return this.http.post<PropertyVisitList>(PropertyVisit_ReadByBusinessId, data);
    }
}